import { UPDATE_MODEL_VALUE } from '../../constants';
import { type PropType } from 'vue';
import { type ComponentSizes, componentDefaultSize } from '../../constants';

export interface SwitchProps {
    modelValue: boolean;
    disabled?: boolean;
    size?: ComponentSizes;
}

export const switchProps = {
    modelValue: {
        type: Boolean as PropType<SwitchProps['modelValue']>,
        default: undefined,
        required: true,
    },
    disabled: {
        type: Boolean as PropType<SwitchProps['disabled']>,
        default: undefined,
        required: false,
    },
    size: {
        type: String as PropType<SwitchProps['size']>,
        default: componentDefaultSize,
        required: false,
    },
};

export const switchEmits = {
    [UPDATE_MODEL_VALUE]: (event: boolean) => event,
    change: (event: boolean) => event,
};
